export class VisitanteModel {

    correoVisitante: string;
    empresa: string;
    nombreCompleto: string;
    tipo: string;
    tipoDocumento: string;
    numeroDocumento: string;



    constructor(correoVisitante: string, empresa: string, nombreCompleto: string,
        tipo: string, tipoDocumento: string, numeroDocumento: string) {

        this.correoVisitante = correoVisitante;
        this.empresa = empresa;
        this.nombreCompleto = nombreCompleto;
        this.tipo = tipo;
        this.tipoDocumento = tipoDocumento;
        this.numeroDocumento = numeroDocumento;
    }



}